module.exports = __webpack_public_path__ + "media/images/icon__close--rb-dark-gray@2x-79dbd7a2f23f21480c6c505fda6fa92f.png";